// Lib
import React from 'react';
import { Box } from '@mui/material';

// Hook
import useUI from '../../../../../hooks/useUI';
import Feather from '../../../../Feather';

import { useStyles } from './OrderInfoItemStyles';

const OrderInfoItem = ({
  title,
  text,
  textColor,
  width = 'initial',
  isMethodPage,
  className,
  isApproved,
  onOpenShippingModal = () => {},
}) => {
  const { classes, cx } = useStyles({ width, textColor, isMethodPage });
  const { isDesktopMode } = useUI();

  if (!text) {
    return;
  }

  return (
    <div className={cx(classes.root, className)}>
      <span className={classes.title}>{`${title}${
        isDesktopMode ? '' : ': '
      }`}</span>
      <Box
        component="span"
        display={isDesktopMode ? 'flex' : 'initial'}
        alignItems="center">
        <span className={classes.text}>{text}</span>
        {isMethodPage && !isApproved && (
          <Feather
            onClick={onOpenShippingModal}
            className={classes.editIcon}
            type="edit"
          />
        )}
      </Box>
      {isMethodPage && isApproved && (
        <div className={classes.secondaryText}>Approved</div>
      )}
    </div>
  );
};

export default OrderInfoItem;
